export default {"src":"/_next/static/media/error.75e32b6c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};